import { Id, Section } from '../types';
import { getChordNotes } from './getChordNotes';
import { getTotalMeasureCount } from './getTotalMeasureCount';
import { get1BeatDurationInSeconds } from './timing';
import * as Tone from 'tone';

function playChordsEachBeat(
	note: string,
	synth: Tone.PolySynth<Tone.Synth<Tone.SynthOptions>>,
	time: number,
	veloctiy: number,
	timeSignature: [number, number]
) {
	const oneBeatDuration = get1BeatDurationInSeconds(timeSignature);

	for (let i = 0; i < timeSignature[0]; i++) {
		synth.triggerAttackRelease(
			note,
			`${timeSignature[1] * 2}n`, // duration
			time + i * oneBeatDuration, // start
			veloctiy
		);
	}
}

const getTimeCode = (measureCount: number) => `${String(measureCount).padStart(2, '0')}:00:00`;

function playSectionChords(
	{ chords, repeatCount }: Section,
	timeSignature: [number, number],
	synth: Tone.PolySynth<Tone.Synth<Tone.SynthOptions>>,
	measureCount: number,
	setCurrentSection: (sectionId: Id | null) => {
		payload: Id | null;
		type: 'app/setActiveSectionId';
	},
	setCurrentChord: (chordId: Id | null) => {
		payload: Id | null;
		type: 'app/setActiveChordId';
	},
	setCurrentSectionRepeatIndex: (repeatIndex: number) => {
		payload: number;
		type: 'app/setActiveSectionRepeatIndex';
	}
) {
	let measures = { count: measureCount };
	for (let n = 0; n < repeatCount; n++) {
		chords.forEach(chord => {
			const { key, flavourId } = chord;

			// get chord notes
			const notes = getChordNotes(key, flavourId).map(note => note.name + note.octave);

			const noteVelocity = 1 / notes.length;

			for (let x = 0; x < chord.length; x++) {
				const timeCode = getTimeCode(measures.count);
				if (window != null) {
					Tone.Transport.schedule(time => {
						// set active chord
						setCurrentSection(chord.parentSectionId);
						setCurrentChord(chord.id);
						setCurrentSectionRepeatIndex(n);
						// play chord
						notes.forEach(note => {
							playChordsEachBeat(note, synth, time, noteVelocity, timeSignature);
						});
					}, timeCode);
				}
				measures.count += 1;
			}
		});
	}

	return measures.count;
}

export function playChords(
	synth: Tone.PolySynth<Tone.Synth<Tone.SynthOptions>>,
	sections: Section[],
	setCurrentSection: (sectionId: Id | null) => {
		payload: Id | null;
		type: 'app/setActiveSectionId';
	},
	setCurrentChord: (chordId: Id | null) => {
		payload: Id | null;
		type: 'app/setActiveChordId';
	},
	setCurrentSectionRepeatIndex: (repeatIndex: number) => {
		payload: number;
		type: 'app/setActiveSectionRepeatIndex';
	},
	timeSignature: [number, number]
) {
	const totalMeasureCount = getTotalMeasureCount(sections);
	const endOfChordsTimeCode = getTimeCode(totalMeasureCount);

	let measureCount = 0;
	sections.forEach((section, i) => {
		measureCount = playSectionChords(
			section,
			timeSignature,
			synth,
			measureCount,
			setCurrentSection,
			setCurrentChord,
			setCurrentSectionRepeatIndex
		);
	});
	if (window != null) {
		Tone.Transport.schedule(time => {
			Tone.Transport.stop();
			Tone.Transport.start();
		}, endOfChordsTimeCode);
	}
}
